import { isConsentCategoryDisabled } from '@/tscapi/utils/consent';

$(function () {
    const pdpUrl = document.referrer.replace('&openreview=true', '');
    loadWriteReview();
    $('#backToProduct').on('click', function (event) {
        window.location.href = pdpUrl;
    });
});

function loadWriteReview() {
    const config: {
        api_key: string;
        locale: string;
        merchant_group_id: string;
        merchant_id: string;
        on_submit: (component: any, data: any) => void;
        components: { Write: string };
        sm_data?: string;
        enable_front_end_iovation_validation?: boolean;
    } = {
        api_key: 'b98bac63-38d8-44ac-9c40-3e650c5439a6',
        locale: 'en_CA',
        merchant_group_id: '12623',
        merchant_id: '3077',
        //  pr_page_id: productData.ItemNo,
        on_submit: function (component, data) {
            window.scrollTo(0, 0);
        },
        components: {
            Write: 'pr-write',
        },
    };
    if (isConsentCategoryDisabled('targeting')) {
        config.sm_data = 'DISABLED';
        config.enable_front_end_iovation_validation = false;
    }
    window.pwr =
        window.pwr ||
        function () {
            // eslint-disable-next-line prefer-rest-params
            (pwr.q = pwr.q || []).push(arguments);
        };
    window.pwr('render', config);
}
export {};
